'use strict';

exports.__esModule = true;
exports.removeUndefined = undefined;

var _lodash = require('lodash');

var removeUndefined = exports.removeUndefined = function removeUndefined(obj) {
    var isObjArray = (0, _lodash.isArray)(obj);
    var newObj = isObjArray ? [] : {};

    (0, _lodash.each)(obj, function (val, i) {
        if (val !== undefined) {
            var newVal = (0, _lodash.isPlainObject)(val) || (0, _lodash.isArray)(val) ? removeUndefined(val) : val;

            if (isObjArray) newObj.push(newVal);else newObj[i] = newVal;
        }
    });

    return newObj;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/objectHelpers.js
// module id = 213
// module chunks = 0